import {
  colors,
  getBorderRadius,
  getSpacing,
  heights,
  spacing,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';

const getContainerHeight = (isMobile: boolean) => {
  const menuAndPaddingHeight =
    heights[isMobile ? 'xl' : 'l'] + spacing.l + spacing.m;
  return `calc(100vh - ${menuAndPaddingHeight}px)`;
};

export const StyledContactLink = styled.a`
  color: ${colors.blue};
  text-decoration: underline;
`;

export const StyledErrorWrapper = styled.div<{ isMobile: boolean }>`
  height: ${({ isMobile }) => getContainerHeight(isMobile)};
  display: flex;
  flex-direction: column;
`;

export const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.gray2};
  border-radius: ${getBorderRadius('l')};
  gap: ${getSpacing('xxs')};
  flex-grow: 1;
  padding: ${getSpacing('l')};
  text-align: center;
  outline: none;
`;
